import { PublicImageItem } from '~/Nova/scenes/HostingList/utils/types';

import { APPLICATION_SEARCH_FIELDS, OS_SEARCH_FIELDS } from './constants';
import { SearchField } from './types';

const buildSearchText = (
  image: PublicImageItem,
  fields: readonly SearchField[],
): string =>
  fields
    .map((field) => image[field])
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

export const buildApplicationSearchText = (image: PublicImageItem): string =>
  buildSearchText(image, APPLICATION_SEARCH_FIELDS);

export const buildOsSearchText = (image: PublicImageItem): string =>
  buildSearchText(image, OS_SEARCH_FIELDS);

export type GroupedImages = Record<string, PublicImageItem[]>;

export const filterApplicationImages = (
  images: PublicImageItem[],
  query: string,
): PublicImageItem[] => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return images;
  return images.filter((image) =>
    buildApplicationSearchText(image).includes(normalizedQuery),
  );
};

export const filterGroupedOsImages = (
  groups: GroupedImages,
  query: string,
): GroupedImages => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return groups;
  return Object.fromEntries(
    Object.entries(groups).filter(
      ([groupName, images]) =>
        groupName.toLowerCase().includes(normalizedQuery) ||
        images.some((image) =>
          buildOsSearchText(image).includes(normalizedQuery),
        ),
    ),
  );
};
